/**
 * Filas de Compartidas conmigo: listas catastrales + showrooms CAD.
 * Cada GET ya viene `shared_with_me_at` DESC; acá se intercalan.
 */

function parseSharedAt(value) {
  const ts = Date.parse(value);
  return Number.isFinite(ts) ? ts : 0;
}

/**
 * @param {object[]} lists filas de `GET /getsharedwithmelists`
 * @param {object[]} cadProjects filas de `GET /getsharedwithmecadprojects`
 * @returns {{ kind: 'list'|'cad', key: string, at: string, row?: object, project?: object }[]}
 */
export function mergeSharedWithMeItems(lists, cadProjects) {
  const items = [
    ...(Array.isArray(lists) ? lists : []).map((row) => ({
      kind: 'list',
      key: `list-${row?.list_id || row?.id || ''}`,
      at: row?.shared_with_me_at || '',
      row,
    })),
    ...(Array.isArray(cadProjects) ? cadProjects : []).map((project) => ({
      kind: 'cad',
      key: `cad-${project?.project_id || project?.id || project?.slug || ''}`,
      at: project?.shared_with_me_at || '',
      project,
    })),
  ];
  return items.sort((a, b) => {
    const delta = parseSharedAt(b.at) - parseSharedAt(a.at);
    if (delta !== 0) return delta;
    return String(a.key).localeCompare(String(b.key));
  });
}

/**
 * Toast de leave/hide. 404 = “no existe”, nunca “no tenés permiso”.
 * @param {number|null|undefined} status
 * @param {string} [apiMessage]
 * @returns {{ title: string, text: string, icon: 'warning'|'error' }}
 */
export function guestShareActionErrorToast(status, apiMessage) {
  const message = typeof apiMessage === 'string' ? apiMessage.trim() : '';
  if (status === 401) {
    return { title: 'Sesión', text: 'Iniciá sesión nuevamente.', icon: 'warning' };
  }
  if (status === 404) {
    return {
      title: 'No encontrada',
      text: 'Esta colección ya no está en tu panel.',
      icon: 'warning',
    };
  }
  if (status === 400) {
    return { title: 'Datos inválidos', text: message || 'Solicitud incorrecta.', icon: 'error' };
  }
  return {
    title: 'Error',
    text: message || 'No se pudo completar la acción.',
    icon: 'error',
  };
}
